import React from "react";
import { NavLink } from "react-router-dom";

const locations = [
  {
    image: require("./../../images/our-history/reception.PNG"),
    title: "Receptions",
    id: "Receptions",
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  },
  {
    image: require("./../../images/our-history/weeding.jpg"),
    title: "Weddings",
    id: "Weddings",
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  },
  {
    image: require("./../../images/our-history/home-decor.JPG"),
    title: "Home Decor",
    id: "Home-Decor",
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  },
  {
    image: require("./../../images/our-history/preweeding.JPG"),
    title: "Pre-Wedding",
    id: "Pre-Wedding",
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  },
  {
    image: require("./../../images/our-history/rental.JPG"),
    title: "Rentals",
    id: "Rentals",
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  },
];

var bgimg1 = require("./../../images/background/cross-line.png");

class About4 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 p-b50 bg-blue inner-page-padding">
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-left">
                <div className="sx-separator bg-repeat-x">
                  <h3 className="sep-line-one">Our Services</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content ">
              <div className="our-history text-black">
                {locations.map((item, index) => (
                  <div className="row" key={index}>
                    <div className="col-12 pic-bg-border">
                      <div
                        className="our-history-pic bg-no-repeat bg-center bg-cover"
                        // data-stellar-background-ratio="0.5"
                        style={{ backgroundImage: "url(" + item.image + ")" }}
                      ></div>
                    </div>
                    <div className="col-12">
                      <div className="our-history-content m-b30">
                        <div className="large-title">
                          <h2 className="m-t0">{item.title}</h2>
                          <h6>{item.location}</h6>
                        </div>
                        {/* <p>{item.description}</p> */}
                        {item.id === "Rentals" ? (
                          <NavLink
                            to={"/rentals-list"}
                            className="site-button-secondry btn-half"
                          >
                            <span> See More</span>
                          </NavLink>
                        ) : (
                          <NavLink
                            to={"/services/" + item.id}
                            className="site-button-secondry btn-half"
                          >
                            <span> See More</span>
                          </NavLink>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default About4;
